import { render, staticRenderFns } from "./sport-icon.vue?vue&type=template&id=00ac2943&lang=pug"
import script from "./sport-icon.vue?vue&type=script&lang=coffee"
export * from "./sport-icon.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports